import { HTMLProps } from "react";
import { useImpersonationRestriction } from "hooks/use-impersonation-restriction";

export const ImpersonationAwareForm = ({ children, ...rest }: HTMLProps<HTMLFormElement>) => {
  const { shouldRestrict } = useImpersonationRestriction();

  return <form noValidate inert={shouldRestrict ? true : undefined} {...rest}>{children}</form>;
}
